import { render, staticRenderFns } from "./NewsletterType.vue?vue&type=template&id=499f6d77&"
import script from "./NewsletterType.vue?vue&type=script&lang=js&"
export * from "./NewsletterType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports